import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { headersTable, valoresOffcanvas } from './auxiliarCores';
import BarraInferiorBotoes from '../../../../../components/BarraInferiorBotoes';
import BarraSubAbas from '../../../../../components/BarraSubAbas';
import ContainerConteudo from '../../../../../components/ContainerConteudo';
import Tabela from '../../../../../components/Tabela';
import WorkspaceBotoes from '../../../../../components/WorkspaceBotoes';
import { getUser } from '../../../../../modules/contexts/Auth/RequireAuth';
import { getAllCores } from '../../../../../services/cores/corService';
import { useExcelExport } from '../../../../../utils/excel-export';
import {
  formataNomeMeioSiglas,
  formatDate,
  formatDateToFile,
} from '../../../../../utils/functions';
import { getSubAbas } from '../../subabas';

const CorListagem: React.FC = () => {
  const navigate = useNavigate();
  const user = getUser();
  const userID = user.sub;
  const [data, setData] = useState<any[]>([]);

  const fetchData = async () => {
    try {
      const registros = await getAllCores();
      setData(registros);
    } catch (error: any) {
      console.error('Erro ao buscar Cores:', error);
    }
  };
  // Buscar dados
  useEffect(() => {
    fetchData();
  }, []);

  // TABELA E OFFCANVAS
  const tableData = data.map((item) => ({
    id: item.id,
    codigoHexadecimal: (
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <span>{item.codigoHexadecimal}</span>
        <div
          style={{
            width: '20px',
            height: '20px',
            borderRadius: '4px',
            border: '1px solid #ccc',
            backgroundColor: item.codigoHexadecimal,
          }}
        />
      </div>
    ),
    nomeCor: item.nomeCor,
    observacoes: item.observacoes,
  }));

  const offCanvasData = data.map((item) => {
    return {
      id: item.id,
      dataRegistro:
        formatDate(item.dataRegistro) +
        ' - ' +
        formataNomeMeioSiglas(item.usuarioRegistro.nomeCompleto),
      dataUltimaAtualizacao:
        formatDate(item.dataUltimaAtualizacao) +
        ' - ' +
        formataNomeMeioSiglas(item.usuarioAtualizacao.nomeCompleto),

      dataUltimaVisualizacao:
        formatDate(item.dataUltimaVisualizacao) +
        ' - ' +
        formataNomeMeioSiglas(item.usuarioUltimaVisualizacao.nomeCompleto),
      nEdicoes: item.nEdicoes || 0,
      nVisualizacoes: item.nVisualizacoes || 0,
      nVisualizadores: item.nVisualizadores || 0,
      separadorLog: '',
      codigoHexadecimal: (
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            gap: '8px',
          }}
        >
          <span>{item.codigoHexadecimal}</span>
          <div
            style={{
              width: '20px',
              height: '20px',
              borderRadius: '4px',
              border: '1px solid #ccc',
              backgroundColor: item.codigoHexadecimal,
            }}
          />
        </div>
      ),
      nomeCor: item.nomeCor,
      separadorObservacoes: '',
      observacoes: item.observacoes,
    };
  });

  const handleClickInserir = () => {
    navigate('cor/dadosgerais');
  };

  const { exportData, isExporting } = useExcelExport('listagemcores');
  const handleExport = async () => {
    try {
      await exportData(
        data,
        `sisaf_cores_${formatDateToFile(new Date().toISOString())}.xlsx`,
        userID,
        'Listagem de Cores',
        'DAF',
      );
    } catch (error) {
      console.error('Erro na exportação:', error);
    }
  };

  return (
    <>
      <BarraSubAbas subAbas={getSubAbas()} />

      <ContainerConteudo>
        <Tabela
          headers={headersTable}
          dataTable={tableData}
          dataOffCanvas={offCanvasData}
          displayValues={valoresOffcanvas}
          tituloCanvas="Cor"
          resultRow={true}
          onRowClick={(row: any) => {
            const id = row.id;
            window.location.href = `#/daf/adm/cores/cor/${id}/dadosgerais`;
          }}
          onAbrirOffCanvasClick={(row: any) => {
            const id = row.id;
            window.location.href = `#/daf/adm/cores/cor/${id}/dadosgerais`;
          }}
        />
      </ContainerConteudo>

      <BarraInferiorBotoes>
        <WorkspaceBotoes
          inserir
          onClickInserir={handleClickInserir}
          download
          onClickDownload={handleExport}
        />
      </BarraInferiorBotoes>
    </>
  );
};

export default CorListagem;
